var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-speed-dial",
    {
      staticClass: "speeddial",
      attrs: { direction: "bottom" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "speed-dial-activator",
                  attrs: { small: "", depressed: "", rounded: "" },
                },
                [
                  _vm.fab_aspect
                    ? _c("v-icon", { attrs: { small: "" } }, [_vm._v("close")])
                    : _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("aspect_ratio"),
                      ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.fab_aspect,
        callback: function ($$v) {
          _vm.fab_aspect = $$v
        },
        expression: "fab_aspect",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-btn-toggle",
        {
          attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
          model: {
            value: _vm.tavoloLayoutModel,
            callback: function ($$v) {
              _vm.tavoloLayoutModel = $$v
            },
            expression: "tavoloLayoutModel",
          },
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.TAVOLO_LAYOUT.CERCHIO },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "v-icon",
                { class: _vm.colorSpeedDial, attrs: { small: "" } },
                [_vm._v("lens")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.TAVOLO_LAYOUT.GRIGLIA },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("v-icon", { class: _vm.colorSpeedDial }, [
                _vm._v("view_module"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn-toggle",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.tavoloLayoutModel == _vm.Constants.TAVOLO_LAYOUT.CERCHIO,
              expression:
                "tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO",
            },
          ],
          staticClass: "icone-cerchi",
          attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
          model: {
            value: _vm.tavoloSizeModel,
            callback: function ($$v) {
              _vm.tavoloSizeModel = $$v
            },
            expression: "tavoloSizeModel",
          },
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.TAVOLO_SIZE.SMALL },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_c("v-icon", { class: _vm.colorSpeedDial }, [_vm._v("lens")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.TAVOLO_SIZE.MEDIUM },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_c("v-icon", { class: _vm.colorSpeedDial }, [_vm._v("lens")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.TAVOLO_SIZE.LARGE },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_c("v-icon", { class: _vm.colorSpeedDial }, [_vm._v("lens")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn-toggle",
        {
          staticClass: "icone-cerchi",
          attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
          model: {
            value: _vm.squadreSizeModel,
            callback: function ($$v) {
              _vm.squadreSizeModel = $$v
            },
            expression: "squadreSizeModel",
          },
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.SQUADRE_SIZE.SMALL },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("v-icon", { class: _vm.colorSpeedDial }, [
                _vm._v("account_box"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.SQUADRE_SIZE.MEDIUM },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("v-icon", { class: _vm.colorSpeedDial }, [
                _vm._v("account_box"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "speed-dial-btn",
              attrs: { value: _vm.Constants.SQUADRE_SIZE.LARGE },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("v-icon", { class: _vm.colorSpeedDial }, [
                _vm._v("account_box"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }